import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const link = e.target.value;
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-background-50">
      {/* Background image overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20magazine%20editorial%20flat%20lay%20with%20colorful%20sneakers%20scattered%20among%20abstract%20geometric%20shapes%20on%20warm%20sand%20colored%20surface%2C%20creative%20composition%20with%20asymmetrical%20negative%20space%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20aesthetic%2C%20cream%20and%20terracotta%20tones%2C%20high%20fashion%20conceptual%20photography%2C%20artistic%20shadow%20play%2C%20sophisticated%20design&width=1600&height=1000&seq=hero-main-v2-a1&orientation=landscape"
          alt="Hoobuy Spreadsheet fashion products collage"
          title="HoobuySpreadsheet 2026 - Produtos Premium"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/12 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-16 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left Content */}
          <div className="w-full lg:w-[42%] text-center lg:text-left">
            <span className="inline-block px-5 py-2 rounded-full bg-white/90 text-foreground-800 text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
              Planilhas Atualizadas 2026
            </span>
            <h1 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              HoobuySpreadsheet<br />
              <span className="italic font-normal">As Melhores Planilhas</span><br />
              Atualizadas para Comprar<br />
              Produtos Premium
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-md mx-auto lg:mx-0 leading-relaxed">
              Encontre os melhores produtos organizados em <strong className="text-foreground-900">hoobuyspreadsheet</strong>, com listas atualizadas diariamente, comparações e guias completos para economizar dinheiro em compras internacionais.
            </p>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 h-14 px-8 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
              >
                Acessar HoobuySpreadsheet
                <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 h-14 px-8 rounded-full border-2 border-foreground-300 text-foreground-800 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/80 transition-all"
              >
                buy it now
                <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>

            {/* Mobile Dropdown */}
            <div className="mt-8 lg:hidden">
              <select
                onChange={handleDropdownChange}
                defaultValue=""
                className="w-full h-12 px-4 rounded-full border border-secondary-300 bg-white/90 text-foreground-700 text-sm font-medium cursor-pointer appearance-none text-center"
                style={{
                  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23555' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 16px center",
                  paddingRight: "40px"
                }}
              >
                <option value="">-- Escolha uma Categoria --</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.link}>
                    {cat.namePt} ({cat.count} links)
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Right Image Area */}
          <div className="w-full lg:w-[58%] relative">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20accessories%20including%20leather%20handbag%2C%20gold%20watch%2C%20aviator%20sunglasses%20and%20silk%20scarf%20arranged%20artfully%20on%20warm%20sand%20colored%20textured%20surface%2C%20soft%20diffused%20natural%20light%20from%20large%20window%2C%20editorial%20luxury%20product%20photography%2C%20cream%20and%20beige%20tones%20with%20hints%20of%20gold%2C%20sophisticated%20styling%2C%20clean%20elegant%20composition%2C%20high%20detail%20textures&width=900&height=700&seq=hero-side-v2-b2&orientation=landscape"
                alt="Hoobuy Spreadsheet - Produtos premium de moda"
                title="HoobuySpreadsheet - Melhores produtos"
                className="w-full h-[420px] md:h-[560px] object-cover object-top rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}